import {
  Directive,
  ElementRef,
  HostListener,
  Renderer2,
  OnInit,
} from "@angular/core";

@Directive({
    selector: "[appIconHover]",
    standalone: false
})
export class IconHoverDirective implements OnInit {
  private _iconElement: HTMLElement;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    this._iconElement = this.elementRef.nativeElement.querySelector("ion-icon");
  }

  /**
   *  Set the icon name on mouse enter
   * @param event mouse event
   */
  @HostListener("mouseenter", ["$event"]) onMouseEnter(event: MouseEvent) {
    if (
      event.target === this.elementRef.nativeElement ||
      event.target === this._iconElement
    ) {
      this.setHoverIconName(true);
    }
  }

  /**
   *  Reset the icon name based on mouse leave event
   * @param event mouse event
   */
  @HostListener("mouseleave", ["$event"]) onMouseLeave(event: MouseEvent) {
    if (
      event.target === this.elementRef.nativeElement ||
      event.target === this._iconElement
    ) {
      this.setHoverIconName(false);
    }
  }

  /**
   *  Set the icon name based on the hover state
   * @param isHovered boolean to set the icon name
   */
  private setHoverIconName(isHovered: boolean) {
    const iconName = this._iconElement.getAttribute("name");
    if (iconName) {
      const hoverSuffix = isHovered ? "" : "-outline";
      const hoverIconName = iconName.replace("-outline", "") + hoverSuffix;
      this.renderer.setAttribute(this._iconElement, "name", hoverIconName);
    }
  }
}
